import { MessageReadParams } from "../entities/updateMessageReadSocket";
import { ChatSocketRepository } from "../repositories/ChatSocketRepository";

export class UpdateMessageRead {
	constructor(private repository: ChatSocketRepository) {}

	execute(params: UpdateMessageReadParams): Promise<void> {
		return this.repository.updateMessageRead(params.params);
	}
}
export class UpdateMessageReadParams {
	constructor(public params: MessageReadParams) {}
}
